import React from 'react';
import { Link } from 'react-router-dom';
import './RechnerGallery.css';

const RechnerGallery = () => {
  const rechnerList = [
    {
      id: 1,
      name: 'Brutto-Netto-Rechner',
      description: 'Berechnen Sie schnell und einfach Ihr Nettogehalt aus dem Bruttogehalt',
      icon: 'calculator',
      category: 'Lohn & Gehalt',
      color: '#3b82f6'
    },
    {
      id: 2,
      name: 'Einkommensteuertabelle',
      description: 'Übersichtliche Darstellung der Einkommensteuer nach Steuerstufen',
      icon: 'chart',
      category: 'Steuern',
      color: '#8b5cf6'
    },
    {
      id: 3,
      name: 'Lohnsteuertabelle',
      description: 'Ermitteln Sie die Lohnsteuer für verschiedene Einkommensstufen',
      icon: 'document',
      category: 'Lohn & Gehalt',
      color: '#06b6d4'
    },
    {
      id: 4,
      name: 'Sachbezug Dienstwohnung',
      description: 'Berechnung des Sachbezugswerts für eine Dienstwohnung',
      icon: 'home',
      category: 'Lohn & Gehalt',
      color: '#10b981'
    },
    {
      id: 5,
      name: 'Pauschalratendarlehen-Rechner',
      description: 'Berechnen Sie Ihre monatlichen Raten für Ihr Darlehen',
      icon: 'bank',
      category: 'Finanzen',
      color: '#f59e0b'
    },
    {
      id: 6,
      name: 'Anspruchsverzinsungs-Rechner',
      description: 'Ermittlung von Verzugszinsen und Anspruchsverzinsung',
      icon: 'trending',
      category: 'Finanzen',
      color: '#ef4444'
    },
    {
      id: 7,
      name: 'Gewinnfreibetragsrechner',
      description: 'Berechnen Sie Ihren steuerlichen Gewinnfreibetrag',
      icon: 'briefcase',
      category: 'Steuern',
      color: '#6366f1'
    },
    {
      id: 11,
      name: 'Reisekostenabrechnung',
      description: 'Excel-Vorlage zur einfachen Erfassung und Abrechnung Ihrer Reisekosten',
      icon: 'download',
      category: 'Steuern',
      color: '#16a34a',
      type: 'download',
      downloadUrl: '/Vorlage Reisekostenabrechnung.xlsx'
    },
    {
      id: 8,
      name: 'Lohnnebenkosten-Rechner',
      description: 'Ermittlung der Lohnnebenkosten für Arbeitgeber',
      icon: 'coins',
      category: 'Lohn & Gehalt',
      color: '#14b8a6'
    },
    {
      id: 9,
      name: 'Lohnpfändungsrechner',
      description: 'Berechnung des pfändbaren Einkommens',
      icon: 'scale',
      category: 'Lohn & Gehalt',
      color: '#ec4899'
    },
    {
      id: 10,
      name: 'Skontoberechnung',
      description: 'Berechnen Sie Skonto und effektive Zinssätze',
      icon: 'percent',
      category: 'Finanzen',
      color: '#f97316'
    }
  ];

  const getIcon = (iconName) => {
    const icons = {
      calculator: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
          <rect x="4" y="2" width="16" height="20" rx="2"/>
          <line x1="8" y1="6" x2="16" y2="6"/>
          <line x1="16" y1="14" x2="16" y2="18"/>
          <line x1="8" y1="14" x2="8" y2="14.01"/>
          <line x1="12" y1="14" x2="12" y2="14.01"/>
          <line x1="8" y1="18" x2="8" y2="18.01"/>
          <line x1="12" y1="18" x2="12" y2="18.01"/>
        </svg>
      ),
      chart: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
          <line x1="12" y1="20" x2="12" y2="10"/>
          <line x1="18" y1="20" x2="18" y2="4"/>
          <line x1="6" y1="20" x2="6" y2="16"/>
        </svg>
      ),
      document: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
          <polyline points="14 2 14 8 20 8"/>
          <line x1="16" y1="13" x2="8" y2="13"/>
          <line x1="16" y1="17" x2="8" y2="17"/>
          <polyline points="10 9 9 9 8 9"/>
        </svg>
      ),
      home: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
          <polyline points="9 22 9 12 15 12 15 22"/>
        </svg>
      ),
      bank: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
          <line x1="3" y1="21" x2="21" y2="21"/>
          <line x1="5" y1="21" x2="5" y2="10"/>
          <line x1="9" y1="21" x2="9" y2="10"/>
          <line x1="15" y1="21" x2="15" y2="10"/>
          <line x1="19" y1="21" x2="19" y2="10"/>
          <polyline points="2 10 12 3 22 10"/>
        </svg>
      ),
      trending: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/>
          <polyline points="17 6 23 6 23 12"/>
        </svg>
      ),
      briefcase: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
          <rect x="2" y="7" width="20" height="14" rx="2" ry="2"/>
          <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/>
        </svg>
      ),
      coins: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="8" cy="8" r="6"/>
          <path d="M18.09 10.37A6 6 0 1 1 10.34 18"/>
          <path d="M7 6h1v4"/>
          <line x1="7" y1="10" x2="9" y2="10"/>
        </svg>
      ),
      scale: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
          <line x1="12" y1="3" x2="12" y2="21"/>
          <path d="M5 9l-3 6h6l-3-6z"/>
          <path d="M19 9l-3 6h6l-3-6z"/>
        </svg>
      ),
      percent: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
          <line x1="19" y1="5" x2="5" y2="19"/>
          <circle cx="6.5" cy="6.5" r="2.5"/>
          <circle cx="17.5" cy="17.5" r="2.5"/>
        </svg>
      ),
      download: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
          <polyline points="7 10 12 15 17 10"/>
          <line x1="12" y1="15" x2="12" y2="3"/>
        </svg>
      )
    };
    return icons[iconName] || icons.calculator;
  };

  return (
    <section className="rechner-gallery">
      <div className="rechner-gallery__container">
        <div className="rechner-gallery__header">
          <h2 className="rechner-gallery__title">Steuerrechner</h2>
          <p className="rechner-gallery__subtitle">
            Nutzen Sie unsere intelligenten Online-Rechner für schnelle und präzise Berechnungen
          </p>
        </div>

        <div className="rechner-gallery__scroll-container">
          <div className="rechner-gallery__grid">
          {rechnerList.map((rechner) => (
            <div 
              key={rechner.id} 
              className="rechner-gallery__card"
              style={{ '--card-color': rechner.color }}
            >
              <div className="rechner-gallery__card-header">
                <div className="rechner-gallery__card-icon">
                  {getIcon(rechner.icon)}
                </div>
                <span className="rechner-gallery__card-category">
                  {rechner.category}
                </span>
              </div>
              
              <div className="rechner-gallery__card-content">
                <h3 className="rechner-gallery__card-title">{rechner.name}</h3>
                <p className="rechner-gallery__card-description">
                  {rechner.description}
                </p>
              </div>

              <Link 
                to={`/rechner/${rechner.id}`}
                className="rechner-gallery__card-button"
              >
                Jetzt berechnen
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </Link>
            </div>
          ))}
          </div>
        </div>

        <Link to="/rechner" className="rechner-gallery__all-link">
          Alle Rechner ansehen
        </Link>
      </div>
    </section>
  );
};

export default RechnerGallery;

